const CrossIconBlack = (props: any) => {
  return (
    <svg
      {...props}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.490234 2.17648C0.490234 0.974444 1.46468 0 2.66671 0H12.8236C14.0256 0 15.0001 0.974442 15.0001 2.17648V12.3334C15.0001 13.5354 14.0256 14.5098 12.8236 14.5098H2.66671C1.46468 14.5098 0.490234 13.5354 0.490234 12.3334V2.17648Z"
        fill="black"
        fillOpacity="0.84"
      />
      <g clipPath="url(#clip0_8768_14826)">
        <path
          d="M8.54565 7.2554L11.2582 4.54277C11.3328 4.46809 11.3739 4.36847 11.3741 4.26224C11.3741 4.15595 11.3329 4.05621 11.2582 3.98166L11.0205 3.74402C10.9457 3.66917 10.8461 3.62817 10.7398 3.62817C10.6336 3.62817 10.534 3.66917 10.4592 3.74402L7.74672 6.45647L5.03409 3.74402C4.95947 3.66917 4.85979 3.62817 4.7535 3.62817C4.64733 3.62817 4.54765 3.66917 4.47304 3.74402L4.23522 3.98166C4.08045 4.13643 4.08045 4.38817 4.23522 4.54277L6.94779 7.2554L4.23522 9.96791C4.16055 10.0427 4.11944 10.1423 4.11944 10.2486C4.11944 10.3548 4.16055 10.4544 4.23522 10.5291L4.47298 10.7668C4.54759 10.8416 4.64733 10.8826 4.75344 10.8826C4.85973 10.8826 4.95941 10.8416 5.03403 10.7668L7.74666 8.05427L10.4592 10.7668C10.5339 10.8416 10.6335 10.8826 10.7397 10.8826H10.7398C10.846 10.8826 10.9457 10.8416 11.0204 10.7668L11.2581 10.5291C11.3327 10.4545 11.3739 10.3548 11.3739 10.2486C11.3739 10.1423 11.3327 10.0427 11.2581 9.96797L8.54565 7.2554Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8768_14826">
          <rect
            width="7.25492"
            height="7.25492"
            fill="white"
            transform="translate(4.11719 3.62744)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CrossIconBlack;
